import type { BrandSelectOption } from "@/features/brands/shared/hooks/useGetBrandsByProjectId";

export const MOCKED_BRANDS: BrandSelectOption[] = [
  { id: 1, name: "Brand 1", profilePicture: null, restrictAiAssets: false },
  { id: 2, name: "Brand 2", profilePicture: null, restrictAiAssets: true },
];
